import { render, staticRenderFns } from "./GroupsHeaders.vue?vue&type=template&id=049cf5fa&scoped=true&"
import script from "./GroupsHeaders.vue?vue&type=script&lang=js&"
export * from "./GroupsHeaders.vue?vue&type=script&lang=js&"
import style0 from "./GroupsHeaders.vue?vue&type=style&index=0&id=049cf5fa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049cf5fa",
  null
  
)

export default component.exports